export default "__VITE_ASSET__BVGu7$ic__"